<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-container text-xs-center>
    <v-data-table
      class="elevation-5"
      :headers="headers"
      :items="tableData"
      :search="search"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      @page-count="pageCount = $event"
      loading-text="Loading... Please wait"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      show-group-by
      :group-by.sync="groupBy"
    >
      <template v-slot:[`item.distance`]="{ item }"
        >{{ item.distance }}
        {{
          item.stroke.replace(/(\w)(\w*)/g, function (g0, g1, g2) {
            return g1.toUpperCase() + g2.toLowerCase();
          })
        }}
      </template>
      <!-- <template v-slot:group="{ item }">
        <tr>
          <td colspan="100%">
            <strong>{{ item.firstName }}</strong>
          </td>
        </tr>
      </template> -->
      <template v-slot:[`item.athRankName`]="{ item }">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-chip
              v-on="on"
              :class="getRankTextColor(getRankColor(item.athRankName))"
              :color="getRankColor(item.athRankName)"
              @click="openRankTab(item.athRankName)"
              class="cursor-pointer"
            >
              {{ item.athRankName }}
            </v-chip>
          </template>
          <span>{{ getRankDesc(item.athRankName) }}</span>
        </v-tooltip>
      </template>
      
      <template v-slot:[`item.firstName`]="{ item }">
        <div
          class="cursor-pointer d-inline-flex align-center text-blue font-weight-medium"
          @click="openAthleteTab($route.params.club, item.athleteId)"
          style="gap: 8px;"
        >
          {{ item.firstName }}
          <v-icon x-small>open_in_new</v-icon>
        </div>
      </template>

     <!-- <template v-slot:[`item.meetId`]="{ item }">
        <td>
          {{
            meets.edges
              .find(items => items.node.meetId == item.meetId)
              .node.meetName.replace("Meet Results-", "")
          }}
        </td>
      </template> -->

      <template v-slot:[`item.resultDate`]="{ item }">
        <v-chip
          v-if="compareDate(item.resultDate) && item.athRankName != 'NA'"
          color="red"
          class="white--text"
          >{{ item.resultDate }}
          <v-icon> new_releases </v-icon>
        </v-chip>
        <v-chip v-else>{{ item.resultDate }} </v-chip>
      </template>

      <template v-slot:[`item.place`]="{ item }">
        <v-icon
          v-if="item.place > 0 && item.place <= 3"
          :color="getMedalColor(item.place)"
          class="mr-2"
        >
          fas fa-medal
        </v-icon>
        <span>{{ item.place }}</span>
      </template>

      <template v-slot:[`item.timeToNextRank`]="{ item }">
        <v-chip
          v-if="item.timeToNextRank == '999'"
          color="red"
          class="white--text"
        >
          <v-icon> fas fa-fire </v-icon>
        </v-chip>
        <v-chip v-else
          >{{ item.timeToNextRank.replace(/00:/g, "").replace(/000/g, "") }}
        </v-chip>
      </template>

      <template v-slot:[`item.resultTime`]="{ item }">
        {{ item.resultTime.replace(/00:/g, "").replace("000", "") }}
      </template>

      <template v-slot:[`item.comments`]="{ item }">
        {{ truncate(item.comments === null ? "" : item.comments.trim(), 6) }}
      </template>
      <template v-slot:top>
        <BaseToolbar toolbarTitle="Results & Ranks" v-if="!localZenMode">
          <template v-slot:toolbarSearch>
            <v-flex xs12 sm3>
              <meetDropdown
                @change-meet="onChangeMeet"
                class="mx-sm-4 mb-3 mb-sm-0"
                :parent-meet-id="parentMeetId"
              >
              </meetDropdown>
            </v-flex>
            <v-flex xs12 sm3>
              <AthletesDropdown
                v-on:parentValueChange="onChangeAthlete"
                class="mr-sm-4 mb-3 mb-sm-0"
                :parent-value="parentAthleteId"
              />
            </v-flex>
            <v-flex xs12 sm3>
              <GenderSelection
                @change-gender="onChangeGender"
                class="mr-sm-4"
                :parent-gender="parentGender"
              />
            </v-flex>
          </template>
          <!-- <template v-slot:toolbarBtn v-if="this.isAdmin()"> -->
          <template v-slot:toolbarBtn>
            <!-- Search Input -->
            <v-text-field
              v-if="searchVisible"
              v-model="search"
              label="Search"
              single-line
              hide-details
              filled
              rounded
              dense
              style="margin-right: 8px; max-width: 130px"
            ></v-text-field>
            <!-- Expandable Search Icon -->
            <v-icon
              color="primary"
              @click="
                searchVisible = !searchVisible;
                search = '';
              "
              style="cursor: pointer"
            >
              search
            </v-icon>
            <v-divider vertical style="margin: 0 8px"></v-divider>
            <v-icon              
              class="mr-2"
              color="primary"
              title="Export to PDF"
              @click="exportToPDF"
            >
              picture_as_pdf
            </v-icon>
            <v-divider vertical style="margin: 0 8px"></v-divider>
            <!-- Search Input -->
            <v-dialog
              v-model="dialogFilter"
              :retain-focus="false"
              max-width="700px"
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" dark v-on="on" v-bind="attrs">
                  tune
                </v-icon>
                <!-- <span>{{ "Settings" }} </span> -->
              </template>

              <v-card>
                <!-- <v-card-title>
                <span class="headline">Athlete's Settings</span>
              </v-card-title> -->
                <v-card-text>
                  <span class="headline">Athlete's Settings</span>
                  <v-divider style="margin: 12px"></v-divider>
                  <span class="headline">System Settings</span>
                  <v-divider style="margin: 8px"></v-divider>
                  <v-icon
                    :color="tableMobile == 0 ? 'grey' : 'primary'"
                    small
                    class="mr-2"
                    @click="tableMobile = tableMobile == 0 ? 600 : 0"
                  >
                    display_settings
                  </v-icon>
                  <span>{{ "Mobile Display" }} </span>
                </v-card-text>

                <v-card-actions>
                  <v-btn color="primary" @click="dialogFilter = false"
                    >Close</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-divider vertical style="margin: 0 8px"></v-divider>
            <v-dialog
              v-model="dialog"
              :retain-focus="false"
              max-width="700px"
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <!-- <span>{{ " Add Athlete" }} </span> -->
                <v-icon color="primary" dark v-on="on" v-bind="attrs">
                  add
                </v-icon>
              </template>
            </v-dialog>
          </template>
        </BaseToolbar>
        <v-toolbar
          v-if="!($store.getters.hasZenMode || localZenMode)"
          text
          dark
          color="light-blue darken-4"
          style="
            border-top: 1px solid white !important;
            height: auto !important;
          "
          class="athleteRanksResults_second-toolbar"
          max-height="300px"
        >
          <v-toolbar-items class="flex-column flex-sm-row align-center">
            <catValueDropDown
              :outlined="true"
              :catName="'SWIMMING_FACILITY'"
              v-model.trim="facilityType"
              label="Select facility type"
              v-on:parentValListChange="onChangeFacility"
              :color="'white'"
            />
            <v-divider horizontal class="mx-4"></v-divider>
            <!--v-flex xs12 sm3>
               <v-combobox
                 class="mt-3 mt-sm-0"
                 hide-details
                v-model="level"
                :items="['new', 'best']"
                label="Select level"
                multiple
                outlined
                dense
              ></v-combobox>
            </v-flex-->
            <v-flex xs12 sm1>
              <v-checkbox
                color="red"
                :label="$vuetify.breakpoint.mdAndUp ? 'NewOnly' : ''"
                :value="newOnly"
                v-model="newOnly"
                hide-details
                @change="handleGetRanks()"
              >
              </v-checkbox>
            </v-flex>
            <v-flex xs2 lg1>
              <v-text-field
                v-model.number="daysOld"
                type="number"
                label="Days Old"
                hint="New within defined period"
                @change="handleGetRanks"
              />
            </v-flex>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-flex xs12 sm1>
              <v-checkbox
                color="blue"
                :label="$vuetify.breakpoint.mdAndUp ? 'BestOnly' : ''"
                :value="bestOnly"
                v-model="bestOnly"
                hide-details
                @change="handleGetRanks()"
              >
              </v-checkbox>
            </v-flex>

            <v-flex xs12 sm1>
              <v-checkbox
                color="green"
                :label="$vuetify.breakpoint.mdAndUp ? 'ActiveOnly' : ''"
                :value="activeStatus"
                v-model="activeStatus"
                hide-details
                @change="handleGetRanks()"
              >
              </v-checkbox>
            </v-flex>
            <v-flex xs12 sm1>
              <v-checkbox
                hide-details
                class="ml-sm-4 hidden-xs-only"
                v-model="medals"
                :color="medals ? 'blue' : 'grey'"
                :label="$vuetify.breakpoint.mdAndUp ? 'Medals Only' : ''"
                on-icon="fas fa-medal"
                off-icon="fas fa-medal"
                @change="handleGetRanks()"
              ></v-checkbox>
            </v-flex>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-flex xs12 sm5>
              <DateRange
                class="mt-8 mt-sm-5"
                :parent-from-date="parentFromDate"
                :parent-to-date="parentToDate"
                @change-fromDate="onChangeFromDate"
                @change-toDate="onChangeToDate"
              />
            </v-flex>
          </v-toolbar-items>
        </v-toolbar>
      </template>
      <template v-if="user" v-slot:[`item.action`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> edit </v-icon>
        <v-icon small @click="deleteItem(item)"> delete </v-icon>
      </template>

      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    <rankResultsForm
      :dialog="dialog"
      :index="editedIndex"
      @close-form="closeForm"
      @set-loading="loading = $event"
    />
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AthletesDropdown from "@/components/shared/athletes_dropdown.vue";
import DateRange from "@/components/shared/date_range_from_to.vue";
import GenderSelection from "@/components/shared/gender_selection.vue";
import meetDropdown from "@/components/shared/meet_dropdown.vue";
import BaseToolbar from "@/components/base/BaseToolbar.vue";
import rankResultsForm from "@/components/forms/rankResultsForm.vue";
import { rankResultsTable } from "@/constants/tabelsData.js";
import catValueDropDown from "../../shared/cat_val_dropdown.vue";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { openAthleteTab } from "@/_helpers/index.js";

export default {
  props: {
    initAthleteId: Number,
    fromDate: String,
    toDate: String,
    facilityType: String,
    localZenMode: {
      type: Boolean,
      default: () => false,
    },
    activeStatus: {
      type: Boolean,
      default: () => true,
    },
  },
  components: {
    AthletesDropdown,
    DateRange,
    GenderSelection,
    meetDropdown,
    BaseToolbar,
    rankResultsForm,
    catValueDropDown,
  },
  data() {
    return {
      tableMobile: 0,
      search: "",
      searchVisible: false,
      page: 1,
      sortBy: "resultDate",
      sortDesc: true,
      groupBy: "firstName",
      itemsPerPage: 200,
      pageCount: 0,
      loading: true,
      level: null,
      athleteId: this.initAthleteId,
      parentAthleteId: null,
      meetId: null,
      parentMeetId: null,
      // facilityType: null,
      medals: false,
      isFormValid: true,
      newOnly: null,
      //activeStatus: true,
      bestOnly: null,
      on: "",
      "editedItem.resultTime": "01:00:00.000",
      "editedItem.isOfficial": true,
      daysOld: 31,
      //resultDate: new Date().toISOString().substr(0, 10),
      //fromDate: null,
      parentFromDate: null,
      //toDate: null,
      parentToDate: null,
      isMobile: false,
      gender: null,
      parentGender: null,
      dialog: false,
      dialogFilter: false,
      // TODO Take out this to validation mixin
      durationTimeRules: [
        (v) =>
          // with hours-          /^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)?(?:[.][0-9]{3})?$/.test(
          /^(?:([0-5]?\d):)?([0-5]?\d)?(?:[.][0-9]{3})?$/.test(v) ||
          "Result must be in hh:mm:ss.mil format",
      ],

      //      headers: rankResultsTable,
      editedIndex: -1,
      rankClassification:
        this.$route.params.club == 16 ? "SPORTECOS" : "MDA_SWIMMING",
    };
  },
  created() {
    console.log(rankResultsTable);
    //Distructure URL i.e. this.$route.query
    //distructure from: http://localhost:8080/16/club/Ranks?gender&bestOnly=Y&daysOld=31&facilityType=50m&newOnly=Y

    if (!(Object.entries(this.$route.query).length === 0)) {
      const {
        gender,
        bestOnly,
        newOnly,
        activeStatus,
        daysOld,
        facilityType,
        medals,
        meetId,
        athleteId,
        fromDate,
        toDate,
      } = this.$route.query;
      //assign to current instance variables
      if (gender) {
        this.gender = gender;
        this.parentGender = this.gender;
      }
      if (bestOnly) {
        this.bestOnly = JSON.parse(bestOnly.toLowerCase());
        this.groupBy = null;
        this.sortBy = null;
      }
      if (daysOld) {
        this.daysOld = parseInt(daysOld);
      }
      this.facilityType = facilityType;
      if (newOnly) {
        this.newOnly = JSON.parse(newOnly.toLowerCase());
      }
      if (medals) {
        this.medals = JSON.parse(medals.toLowerCase());
      }
      if (meetId) {
        this.meetId = parseInt(meetId);
        this.parentMeetId = this.meetId;
      }
      if (activeStatus) {
        this.activeStatus = JSON.parse(activeStatus.toLowerCase());
      }
      if (athleteId) {
        this.athleteId = athleteId;
        this.parentAthleteId = this.athleteId;
      }
      if (fromDate) {
        this.fromDate = fromDate;
        this.parentFromDate = this.fromDate;
      }
      if (toDate) {
        this.toDate = toDate;
        this.parentToDate = this.toDate;
      }
    }

    Promise.all([
      this.$store.dispatch("allRankLib", {
        rankClassification: this.rankClassification,
      }),
      this.handleGetRanks(),
    ])
      .then(() => {
        this.loading = false;
      })
      .catch((error) => {
        console.error(error);
        this.loading = false;
      });
    // await this.$store.dispatch("allRecordsList", {
    //   facilityType: String(this.facilityType)
    // });
  },
  computed: {
    ...mapGetters(["categoryValue", "resultsList", "rankLib", "user"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Result" : "Edit Result";
    },
    getFacilityTypes() {
      if (this.categoryValue.edges) {
        return this.categoryValue.edges.filter(
          (category) => category.node.category.catName === "SWIMMING_FACILITY"
        );
      } else {
        return [];
      }
    },
    headers() {
      return rankResultsTable.filter(
        (element) =>
          (this.user && this.user.role == "Administrator") ||
          element.text !== "Actions"
      );
    },
    tableData() {
      if (this.resultsList.length > 0) {
        return this.resultsList.filter(
          (item) =>
            (!this.newOnly ||
              (this.compareDate(item.resultDate) &&
                item.athRankName != "NA")) &&
            (!this.medals || (item.place > 0 && item.place <= 3)) &&
            (!this.gender || item.gender === this.gender) &&
            (!this.athleteId || +item.athleteId === +this.athleteId) &&
            (!this.meetId || +item.meetId === +this.meetId)
            
          //el.facilityType === this.facilityType &&
          // el.gender === this.gender &&
          //       (this.meetId ? +this.meetId === +el.meetId : el.meetId) &&
          //(this.athleteId ? +this.athleteId === +el.athleteId : el.athleteId)
          //       (this.fromDate && this.toDate
          //         ? el.resultDate >= this.fromDate && el.resultDate <= this.toDate
          //         : el.resultDate) &&
          //      (this.medals ? +el.place > 0 && +el.place <= 3 : el.place)
        );
      } else {
        return [];
      }
    },
  },

  watch: {
    "$route.params.league": function () {
      this.handleGetRanks();
    },
    "$route.params.club": function () {
      this.handleGetRanks();
    },
    initAthleteId(val) {
      this.athleteId = val;
    },
    // fromDate(val) {
    //   this.fromDate = val;
    // },
    // toDate(val) {
    //   this.toDate = val;
    // },
    // facilityType(val) {
    //   this.facilityType = val;
    // },
    // $initAthleteId: {
    //   handler() {
    //     this.athleteId = initAthleteId;
    //     //this.handleGetRanks();
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  methods: {
    truncate(text, length) {
      if (!text) return "";
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
    openRankTab(rankCode) {
      const rank = this.rankLib.edges.find(
        (item) => item.node.rankCode === rankCode
      );
      if (rank) {
        const id = rank.node.seqNo; // or whatever identifier your route uses
        const url = `/lib/rank_lib?classification=SPORTECOS`;
        window.open(url, "_blank");
      }
    },
    openAthleteTab,
 exportToPDF() {
      const doc = new jsPDF("landscape"); // landscape for wider tables
      const currentDate = new Date().toLocaleDateString();

      doc.setFontSize(14);
      doc.text("Performance Report", 14, 15);
      doc.setFontSize(10);
      doc.text(`Exported on ${currentDate}`, 14, 22);

      const headers = this.headers
        .filter(h => h.value !== "action")
        .map(h => h.text);

      const rows = this.tableData.map(item => {
        return this.headers
          .filter(h => h.value !== "action")
          .map(h => {
            if (h.value === "distance") {
              return `${item.distance} ${item.stroke[0].toUpperCase()}${item.stroke.slice(1).toLowerCase()}`;
            }
            if (typeof item[h.value] === "string") {
              return item[h.value].replace(/\n/g, " "); // handle line breaks
            }
            return item[h.value];
          });
      });

      autoTable(doc, {
        head: [headers],
        body: rows,
        startY: 28,
        styles: {
          fontSize: 9,
          cellPadding: 3,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 30 },  // Athlete
          1: { cellWidth: 12 },  // Rank
          2: { cellWidth: 20 },  // Event
          3: { cellWidth: 20 },  // Date
          4: { cellWidth: 22 },  // Result
          5: { cellWidth: 20 },  // Comments
          6: { cellWidth: 10, halign: "right" }, // Place
          7: { cellWidth: 10 },  // Facility
          8: { cellWidth: 35 },  // Next Rank
          9: { cellWidth: 35 },  // Meet
          10: { cellWidth: 10, halign: "right" }, // Pts
        },
        theme: "grid",
        headStyles: {
          fillColor: [22, 160, 133],
          textColor: [255, 255, 255],
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
      });

      doc.save("performance-report.pdf");
    },  
    async onChangeFacility(value) {
      this.facilityType = value;
      await this.routerReplace();
    },
    async onChangeAthlete(value) {
      this.athleteId = value;
      await this.routerReplace();
    },
    async onChangeMeet(value) {
      this.meetId = value;
      await this.routerReplace();
    },
    async onChangeGender(value) {
      this.gender = value;
      await this.routerReplace();
    },
    async onChangeFromDate(value) {
      this.fromDate = value;
      await this.handleGetRanks();
    },
    async onChangeToDate(value) {
      this.toDate = value;
      await this.handleGetRanks();
    },
    async onChangeEvent(value) {
      this.editedItem.setLibSetId = value;
      await this.routerReplace();
    },
    getAthletes: function () {
      return Array.from(
        new Set(this.resultsList.map((item) => item.athleteId))
      ).map((athleteId) => {
        return {
          athleteId: athleteId,
          firstName: this.resultsList.find(
            (item) => item.athleteId === athleteId
          ).firstName,
          // lastName: this.athleteResults.edges.find(
          //   item => item.node.athleteId === athleteId
          // ).node.athlete.lastName
        };
      });
    },

    brightnessByColor(color) {
      // eslint-disable-next-line
      var color = "" + color,
        isHEX = color.indexOf("#") == 0,
        isRGB = color.indexOf("rgb") == 0;
      if (isHEX) {
        const hasFullSpec = color.length == 7;
        var m = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g);
        if (m)
          // eslint-disable-next-line
          var r = parseInt(m[0] + (hasFullSpec ? "" : m[0]), 16),
            g = parseInt(m[1] + (hasFullSpec ? "" : m[1]), 16),
            b = parseInt(m[2] + (hasFullSpec ? "" : m[2]), 16);
      }
      if (isRGB) {
        // eslint-disable-next-line
        var m = color.match(/(\d+){3}/g);
        if (m)
          // eslint-disable-next-line
          var r = m[0],
            // eslint-disable-next-line
            g = m[1],
            // eslint-disable-next-line
            b = m[2];
      }
      if (typeof r != "undefined") return (r * 299 + g * 587 + b * 114) / 1000;
    },
    getRankTextColor(rankColor) {
      var brbyColor = this.brightnessByColor(rankColor);

      return brbyColor > 130 ? "black--text" : "white--text";
    },
    getRankColor(rankCode) {
      return rankCode.match(new RegExp("REFRESH"))
        ? "red"
        : this.rankLib.edges.filter((item) => item.node.rankCode == rankCode)[0]
            .node.rankColor;
    },
    getRankDesc(rankCode) {
      return rankCode.match(new RegExp("REFRESH"))
        ? "None"
        : this.rankLib.edges.filter((item) => item.node.rankCode == rankCode)[0]
            .node.rankName;
    },
    getMedalColor(level) {
      var tagcolor = "";
      switch (parseInt(level)) {
        case 1:
          tagcolor = "#FFD700";
          break;
        case 2:
          tagcolor = "#C0C0C0";
          break;
        case 3:
          tagcolor = "#CD7F32";
          break;
        default:
          tagcolor = "grey";
      }
      return tagcolor;
    },
    isAdmin() {
      return this.user && this.user.role == "Administrator";
    },

    async routerReplace() {
      // add query parameters to url
      // example: http://localhost:8080/16/club/Ranks?gender&bestOnly=Y&daysOld=31&facilityType=50m&newOnly=Y

      this.$router.replace({
        query: {
          gender: this.gender,
          bestOnly: this.bestOnly ? this.bestOnly : false,
          newOnly: this.newOnly ? this.newOnly : false,
          activeStatus: this.activeStatus ? this.activeStatus : false,
          daysOld: this.daysOld,
          facilityType: this.facilityType,
          medals: this.medals,
          meetId: this.meetId,
          athleteId: this.athleteId,
          fromDate: this.fromDate,
          toDate: this.toDate,
        },
      });
    },

    async handleGetRanks() {
      this.routerReplace();
      Promise.all([
        this.$store.dispatch("allResultsList", {
          gender: this.gender,
          leagueSeqno: this.$route.params.league,
          clubId: this.$route.params.club,
          teamId: this.teamId,
          athleteId: this.athleteId,
          fromDate: this.fromDate,
          toDate: this.toDate,
          facilityType: this.facilityType,
          bestOnly: this.bestOnly ? 1 : null,
          isNewDays: 130,
          rankClassification: this.rankClassification,
          inAthleteStatus: this.activeStatus ? "active" : null,
        }),
      ])
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
      //this.$router.push(redir_path);
      //reach out of Vuex store, fire action that gets posts for carousel
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    compareDate: function (item) {
      return Math.abs((new Date() - new Date(item)) / 86400000) < this.daysOld;
      //return 1;
    },
    handleAddResult() {
      if (this.athleteId) {
        this.$store.dispatch("resultMerge", {
          resultId: this.editedItem.resultId || 0,
          setLibSetId: this.editedItem.setLibSetId,
          athleteId: this.athleteId,
          setId: this.editedItem.setId || 1,
          resultTime: this.editedItem.resultTime,
          resultDate: this.editedItem.resultDate,
          comments: this.editedItem.comments,
          isOfficial: this.editedItem.isOfficial,
          pulse: this.editedItem.pulse,
          facilityType: this.editedItem.facilityType,
          meetId: this.editedItem.meetId,
          place: this.editedItem.place,
          updateSource: "VueJS",
          firstName: this.editedItem.firstName,
          stroke: this.editedItem.stroke,
          gender: this.editedItem.gender,
        });
      }
    },
    handleDeleteResult() {
      this.$store.dispatch("DeleteResult", {
        resultId: this.editedItem.resultId,
      });
      //}
    },
    editItem(item) {
      this.editedIndex = this.resultsList.findIndex((x) => x === item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },

    deleteItem(item) {
      this.loading = true;
      this.$store
        .dispatch("DeleteResult", {
          resultId: item.resultId,
        })
        .then(() => {
          this.$toast.error("Result has been deleted");
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          this.closeForm();
        });
      // const index = this.resultsList.toString().indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // confirm("Are you sure you want to delete this item?") &&
      //   this.handleDeleteResult(index);
    },

    closeForm() {
      //this.dialog = false;
      this.editedIndex = -1;
    },
    save() {
      this.handleAddResult();
      this.close();
    },
  },
  mounted() {
    console.log("resultsList");
    console.log(this.rankLib);
    //    console.log(tableData());
  },
};
</script>

<style lang="scss">
::-webkit-datetime-edit-ampm-field {
  display: none;
}

::-webkit-datetime-edit-millisecond-field {
  color: red;
  font-variant-numeric: slashed-zero;
  padding: 1px;
}

::-webkit-datetime-edit-hour-field {
  display: none;
  pointer-events: auto;
  color: transparent;
  background: #f5f5f5;
}

@media screen and (max-width: 600px) {
  .v-toolbar__content {
    flex-wrap: wrap !important;
    height: auto !important;
    justify-content: center !important;
  }
}
</style>
